import { render, staticRenderFns } from "./magazine.vue?vue&type=template&id=65e9e168&"
import script from "./magazine.vue?vue&type=script&lang=js&"
export * from "./magazine.vue?vue&type=script&lang=js&"
import style0 from "./magazine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports